import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=4ef645bc&"
import script from "./LogoIcon.vue?vue&type=script&lang=js&"
export * from "./LogoIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogoIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports